import autosize from 'autosize';
import flatpickr from 'flatpickr';
import setupSelectFields from './forms/selects';
import setupCheckboxToggles from './forms/checkbox-toggle';
import setupCheckboxValidation from './forms/checkbox-validation';
import setupRadioValidation from './forms/radio-validation';
import setupConfirmValidation from './forms/confirm-validation';
import setupFileUploaders from './forms/file-upload';
import setupValidationCharCount from './forms/validate-char-count';
import setupValidationMatchingFields from './forms/validate-matching-fields';
import setupResetForm from './forms/reset';
import setupMatchingAddressFields from './forms/matching-addresses';
import setupSfForm from '../account/components/sf-file-upload-form';
import setupValidationAlerts from './forms/validation-alerts';
import setupWformSelectFields from './forms/w-form-selects';
import setupLinkedDropdowns from '../vue/linked-dropdowns';
import setupWForm from './forms/w-form-setup';
import setupWformFileUploadFields from './forms/w-form-file-upload';
import setupProductDropdowns from '../vue/product-dropdowns';
import setupRecaptcha from './forms/recaptcha';

export const setupForm = (form) => {

    const isSfEmbeddedForm = form.parentElement.classList.contains('wForm');

    if (isSfEmbeddedForm) {
        setupWForm(form);
    }

    if (!form.classList.contains('js-form-is-setup')) {
        setupResetForm(form);

        if (isSfEmbeddedForm) {
            // Setup wForms separately to patch functionality. 
            setupWformFileUploadFields(form);
            setupWformSelectFields(form);
        }  else {
            setupSelectFields(form);
            
            const fields = Array.from(form.querySelectorAll('input, select, textarea'));
            fields.forEach(field => setupValidationAlerts(field));
        }

        setupCheckboxToggles(form);
        setupCheckboxValidation(form);
        setupRadioValidation(form);
        setupFileUploaders(form);
        setupConfirmValidation(form);
        setupValidationCharCount(form);
        setupValidationMatchingFields(form);
        setupMatchingAddressFields(form);
        setupLinkedDropdowns(form);
        setupProductDropdowns(form);
        if (form.classList.contains('js-sf-file-upload')) setupSfForm(form);
        setupRecaptcha(form);

        // Textarea
        autosize(form.querySelectorAll('.paragraph textarea'));

        // Stop duplicate form submissions (while server-side check is disabled)
        // const submitButton = form.querySelector('[type=submit], button');
        // form.addEventListener('submit', (e) => {
        //     submitButton.classList.add('btn--disabled');
        // });

        // Date pickers
        Array.from(form.querySelectorAll('.js-date-picker')).forEach((node) => {
            flatpickr(node, {
                minDate: node.dataset.mindate,
                maxDate: node.dataset.maxdate,
                dateFormat: 'd-M-Y',
                allowInput: true,
            });
        });

        form.classList.add('js-form-is-setup');
    }
};

export default (() => {
    const forms = Array.from(document.querySelectorAll('form:not(.popup):not(.no-setup)'));
    forms.forEach((form) => {
        setupForm(form);
    });

    // Hard reset button
    const resets = Array.from(document.querySelectorAll('.js-form-reset'));
    resets.forEach((reset) => {
        reset.addEventListener('click', (e) => {
            e.preventDefault();

            const form = reset.closest('form');
            const inputs = form.querySelectorAll('input');

            inputs.forEach((input) => {
                input.value = '';
            });
        });
    });
})();
